import clsx from 'clsx';

import { MapAsset } from '@atom/types/map';
import { FILES_ENDPOINT } from '@atom/utilities/endpoints';
import { getStaticImage } from '@atom/utilities/mapUtilities';
import markerUtilities from '@atom/utilities/markerUtilities';
import timeUtilities from '@atom/utilities/timeUtilities';

import classes from './drawerContent.module.css';

interface Props {
  asset: MapAsset;
}

const AssetListItem = ({ asset }: Props) => {
  const { name, assetType, markerId, mainPhotoFileId, location } = asset;

  const getSummaryImage = () => {
    return !mainPhotoFileId
      ? getStaticImage(location, '60x60')
      : `${FILES_ENDPOINT}/${mainPhotoFileId}_60`;
  };

  return (
    <div className={classes.listItemV2}>
      <div className={classes.iconContainer}>
        <div
          className={classes.imageContainer}
          style={{
            backgroundImage: `url('${getSummaryImage()}')`,
          }}
        />
      </div>
      <div className={classes.descriptionContainer}>
        <div className={classes.heading}>{name}</div>
        <div className={clsx(classes.secondary, classes.medium)}>
          <img
            className={classes.icon}
            src={markerUtilities.getInactiveAssetIconFromSchemaMarkerId(
              markerId,
            )}
          />
          {assetType}
        </div>
        <div
          className={clsx(classes.secondary, classes.medium)}
        >{`Last Updated: ${timeUtilities.setDisplayDate(
          asset.updatedDate,
        )}`}</div>
      </div>
    </div>
  );
};

export default AssetListItem;
